import * as React from 'react';

import { cn } from '@shared/lib/utils';

import { Text } from '../typography/text';

export interface EmptyStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  description?: React.ReactNode;
  title: React.ReactNode;
}

/** Domain-neutral empty collection/content state for shared data views. */
const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ className, description, title, ...props }, ref) => (
    <div
      ref={ref}
      role="status"
      aria-live="polite"
      className={cn(
        'min-w-0 rounded-md border border-dashed border-border bg-muted/20 px-4 py-6 text-center',
        className
      )}
      data-slot="empty-state"
      {...props}
    >
      <Text as="p" className="font-semibold">
        {title}
      </Text>
      {description ? (
        <Text as="p" size="sm" color="muted" className="mt-1">
          {description}
        </Text>
      ) : null}
    </div>
  )
);
EmptyState.displayName = 'EmptyState';

export { EmptyState };
